// AUTO-GENERATED: 2025-10-28T19:10:34.719174Z
// 🥡 Chinese recipes

export const chineseRecipes = [
{
    name: "Kung Pao Chicken",
    cuisine: "Chinese",
    ingredients: ["chicken breast", "peanuts", "bell peppers", "scallions", "garlic", "ginger"],
    sauces: ["soy sauce", "rice vinegar", "chili paste", "sesame oil", "cornstarch"],
    instructions: "Cut chicken into cubes, marinate with soy sauce and cornstarch. Heat wok on high, stir-fry chicken until golden, remove. Stir-fry garlic, ginger, dried chilies. Add peppers, stir-fry 2 minutes. Return chicken, add sauce (soy, vinegar, chili paste, sugar). Add peanuts and scallions. Toss until coated. Serve over rice.",
    time: "25 min",
    difficulty: "Medium",
    points: 75,
    servings: 2
  },
{
    name: "Fried Rice",
    cuisine: "Chinese",
    ingredients: ["rice", "eggs", "peas", "carrots", "scallions"],
    sauces: ["soy sauce", "sesame oil", "oyster sauce"],
    instructions: "Use day-old cold rice (fresh rice gets mushy). Heat wok on high with oil. Scramble eggs, remove. Add diced carrots and peas, stir-fry 2 minutes. Add rice, breaking up clumps. Stir-fry 3-4 minutes. Add soy sauce, oyster sauce, sesame oil. Fold in eggs and chopped scallions. Serve hot.",
    time: "20 min",
    difficulty: "Easy",
    points: 50,
    servings: 2
  },
{
    name: "Sweet and Sour Pork",
    cuisine: "Chinese",
    ingredients: ["pork", "pineapple", "bell peppers", "onion", "eggs", "flour"],
    sauces: ["ketchup", "rice vinegar", "sugar", "soy sauce", "cornstarch"],
    instructions: "Cut pork into chunks, coat in flour and egg batter. Deep fry until golden and crispy. Make sauce by mixing ketchup, vinegar, sugar, and soy sauce in wok. Add bell peppers, onion, pineapple chunks. Simmer 3 minutes. Add fried pork, toss to coat. Thicken with cornstarch slurry. Serve over rice.",
    time: "35 min",
    difficulty: "Medium",
    points: 75,
    servings: 2
  },
{
    name: "Mapo Tofu",
    cuisine: "Chinese",
    ingredients: ["tofu", "ground pork", "scallions", "garlic", "ginger"],
    sauces: ["doubanjiang", "soy sauce", "sesame oil", "sichuan peppercorns"],
    instructions: "Cut tofu into cubes. Brown ground pork with garlic and ginger. Add doubanjiang (chili bean paste), stir-fry until fragrant. Add chicken broth, soy sauce, and tofu. Simmer gently 5-7 minutes. Add scallions. Thicken with cornstarch slurry. Drizzle with sesame oil. Top with ground sichuan peppercorns. Serve over rice.",
    time: "20 min",
    difficulty: "Medium",
    points: 75,
    servings: 2
  },
{
    name: "Dumplings",
    cuisine: "Chinese",
    ingredients: ["ground pork", "cabbage", "scallions", "ginger", "garlic", "dumpling wrappers"],
    sauces: ["soy sauce", "sesame oil", "rice vinegar", "chili oil"],
    instructions: "Mix ground pork with finely chopped cabbage, scallions, ginger, garlic, soy sauce, and sesame oil. Place spoonful in dumpling wrapper, fold and pleat edges. Steam 8-10 minutes or pan-fry for potstickers. Make dipping sauce with soy sauce, vinegar, sesame oil, and chili oil. Serve hot.",
    time: "60 min",
    difficulty: "Hard",
    points: 100,
    servings: 2
  },
{
    name: "General Tso's Chicken",
    cuisine: "Chinese",
    ingredients: ["chicken thighs", "eggs", "cornstarch", "garlic", "ginger", "dried chilies"],
    sauces: ["soy sauce", "rice vinegar", "hoisin sauce", "sugar", "sesame oil"],
    instructions: "Cut chicken into chunks, coat in cornstarch and egg. Deep fry until crispy, drain. In wok, sauté garlic, ginger, dried chilies. Add sauce (soy, vinegar, hoisin, sugar, chicken broth). Bring to boil. Add fried chicken, toss to coat. Thicken with cornstarch slurry. Garnish with scallions and sesame seeds. Serve over rice.",
    time: "30 min",
    difficulty: "Medium",
    points: 75,
    servings: 2
  },
{
    name: "Hot and Sour Soup",
    cuisine: "Chinese",
    ingredients: ["tofu", "mushrooms", "bamboo shoots", "eggs", "pork"],
    sauces: ["soy sauce", "rice vinegar", "white pepper", "sesame oil", "chili oil"],
    instructions: "Bring chicken broth to simmer. Add sliced mushrooms, bamboo shoots, and shredded pork. Cook 5 minutes. Add diced tofu, soy sauce, vinegar, white pepper. Thicken with cornstarch slurry. Slowly drizzle beaten eggs while stirring to create ribbons. Add sesame oil and chili oil. Garnish with scallions. Serve hot.",
    time: "25 min",
    difficulty: "Medium",
    points: 75,
    servings: 2
  },
{
    name: "Lo Mein",
    cuisine: "Chinese",
    ingredients: ["noodles", "chicken breast", "cabbage", "carrots", "bean sprouts", "scallions"],
    sauces: ["soy sauce", "oyster sauce", "sesame oil", "garlic"],
    instructions: "Cook noodles until al dente, drain. Heat wok on high, stir-fry sliced chicken until cooked. Add garlic, then vegetables (cabbage, carrots, bean sprouts). Stir-fry 3 minutes. Add cooked noodles. Toss with soy sauce, oyster sauce, and sesame oil. Stir-fry until everything is well combined and heated through. Garnish with scallions.",
    time: "25 min",
    difficulty: "Easy",
    points: 50,
    servings: 2
  },
{
    name: "Char Siu",
    cuisine: "Chinese",
    ingredients: ["pork shoulder", "garlic", "ginger"],
    sauces: ["hoisin sauce", "soy sauce", "honey", "five spice", "rice wine"],
    instructions: "Marinate pork strips in hoisin, soy sauce, honey, five-spice, rice wine, garlic, and ginger for 4+ hours or overnight. Preheat oven to 375°F. Place pork on rack over baking sheet. Roast 25 minutes, flip, baste with marinade. Roast 25 more minutes. Broil 2-3 minutes for caramelized edges. Let rest, slice. Serve over rice.",
    time: "60 min + marinade",
    difficulty: "Medium",
    points: 100,
    servings: 2,
    special: true
  },
{
    name: "Wonton Soup",
    cuisine: "Chinese",
    ingredients: ["ground pork", "shrimp", "wonton wrappers", "bok choy", "scallions", "ginger"],
    sauces: ["soy sauce", "sesame oil", "chicken broth"],
    instructions: "Mix ground pork, minced shrimp, ginger, soy sauce, sesame oil. Place spoonful in wonton wrapper, wet edges, fold into triangle, press corners together. Bring chicken broth to boil. Add wontons, cook 5-6 minutes. Add bok choy, cook until tender. Serve hot, garnished with scallions and a few drops of sesame oil.",
    time: "45 min",
    difficulty: "Medium",
    points: 75,
    servings: 2
  }
];
